import * as React from "react";
import { EventTabColor } from "#src/components/svg/constants";
import { EventTabWizardSvgProps } from "#src/components/svg/types";

export const MiniTicketSvg: React.FC<EventTabWizardSvgProps> = (props) => {
	const { color, ...rest } = props;

	let fillColor = EventTabColor.DEFAULT;

	if (color === "active") {
		fillColor = EventTabColor.ACTIVE;
	}

	if (color === "error") {
		fillColor = EventTabColor.ERROR;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={24}
			height={24}
			viewBox="0 0 24 24"
			fill="none"
			{...rest}
		>
			<path
				opacity={0.32}
				d="M22 9.20938V14.7894C22 18.8894 20.75 20.1394 16.65 20.1394H9.91V17.1194C9.91 16.7394 9.59 16.4194 9.21 16.4194V7.57938C9.59 7.57938 9.91 7.25938 9.91 6.87938V3.85938H16.65C20.75 3.85938 22 5.10938 22 9.20938Z"
				fill={fillColor}
			/>
			<path
				d="M18.47 11.9001C18.64 11.7401 18.7 11.4901 18.63 11.2701C18.56 11.0401 18.37 10.8801 18.13 10.8501L16.85 10.6601C16.8 10.6501 16.76 10.6201 16.74 10.5801L16.17 9.42008C16.07 9.21008 15.85 9.08008 15.62 9.08008C15.38 9.08008 15.17 9.21008 15.06 9.42008L14.49 10.5801C14.47 10.6301 14.42 10.6601 14.37 10.6601L13.09 10.8501C12.86 10.8801 12.66 11.0501 12.59 11.2701C12.52 11.5001 12.58 11.7401 12.75 11.9001L13.68 12.8001C13.72 12.8301 13.73 12.8901 13.72 12.9401L13.5 14.2101C13.46 14.4401 13.55 14.6801 13.75 14.8101C13.86 14.8901 13.98 14.9301 14.11 14.9301C14.21 14.9301 14.31 14.9101 14.4 14.8601L15.55 14.2601C15.59 14.2401 15.65 14.2401 15.69 14.2601L16.84 14.8601C17.05 14.9701 17.3 14.9501 17.49 14.8101C17.68 14.6701 17.78 14.4401 17.74 14.2001L17.52 12.9301C17.51 12.8801 17.53 12.8301 17.56 12.7901L18.47 11.9001Z"
				fill={fillColor}
			/>
			<path
				d="M9.21 7.57938V16.4194C8.83 16.4194 8.51 16.7394 8.51 17.1194V20.1394H7.35C3.4 20.1394 2.1 18.9594 2.01 15.2794C2 15.0894 2.08 14.9094 2.21 14.7794C2.34 14.6394 2.53 14.5694 2.71 14.5694C4.11 14.5694 5.26 13.4194 5.26 12.0094C5.26 10.5994 4.11 9.43937 2.71 9.43937C2.51 9.43937 2.34 9.36937 2.21 9.22937C2.08 9.09937 2 8.90937 2.01 8.72937C2.1 5.03937 3.4 3.85938 7.35 3.85938H8.51V6.87938C8.51 7.26938 8.83 7.57938 9.21 7.57938Z"
				fill={fillColor}
			/>
		</svg>
	);
};
